import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { CoreState } from '../state/_state.interfaces';
import { getSession } from '../state/_state.selectors';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LogoutSessions } from '../state/session.actions';

const helper = new JwtHelperService();

/**
 * 認証ガード
 */
@Injectable()
export class AuthGuard implements CanActivate {
  /**
   * コンストラクタ
   */
  constructor(
    private store: Store<CoreState>
  ) {}

  /**
   * アクティブ可能チェック
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // ログインチェック
    return this.store.select(getSession).pipe(
      map((session) => {
        const isLogin = session.login && !helper.isTokenExpired(session.token);
        if (!isLogin) {
          this.store.dispatch(new LogoutSessions());
        }
        return isLogin;
      })
    );
  }
}
